import React from 'react';

import EllipseIcon from '@Components/Icons/EllipseIcon';

interface HeroBulletProps {
    children: React.ReactNode;
    number: number;
}

export const HeroBullet = ({ number, children }: HeroBulletProps) => (
    <div className='flex items-center mb-7 text-lg'>
        <EllipseIcon
            className='mr-4 flex-none text-sm text-midnight-200 font-bold'
            number={number}
        />
        <p className='hero-regular leading-120%'>{children}</p>
    </div>
);
